var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBagsClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33073 42C6.7534 42 4.66406 39.9107 4.66406 37.3333V23.8C4.66406 21.1864 4.66406 19.8796 5.17271 18.8814C5.6201 18.0033 6.33401 17.2894 7.21211 16.842C8.21036 16.3333 9.51716 16.3333 12.1307 16.3333H37.3307C39.2637 16.3333 40.8307 17.9003 40.8307 19.8333M16.3307 16.3333V14C16.3307 10.134 19.4647 7 23.3307 7C27.1968 7 30.3307 10.134 30.3307 14V16.276",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30.5V38L29.25 40.25M46.5 38C46.5 45.4559 40.4559 51.5 33 51.5C25.5442 51.5 19.5 45.4559 19.5 38C19.5 30.5442 25.5442 24.5 33 24.5C40.4559 24.5 46.5 30.5442 46.5 38Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagsClock);
export default __webpack_public_path__ + "static/media/bags-clock.c4f0d67febc581deb4f663f58e51f344.svg";
export { ForwardRef as ReactComponent };